export default {
  alerta: {
    estado: '',
    codOcorrencia: 0,
    placa: '',
    placaValido: false,
    placaCompleta: false,
    cor: 'AMARELA',
    modelo: '',
    idTelegram: [],
    tipoAlerta: '',
    recomendacao: '',
    detalhe: '',
    dataInicial: "",
    optionsDataInicial: {
      format: "DD/MM/YYYY",
      useCurrent: true,
      ignoreReadonly: true
    },
    dataFinal: "",
    optionsDataFinal: {
      format: "DD/MM/YYYY",
      useCurrent: true,
      ignoreReadonly: false
    },
  },
  buscaralertas: {}
  
}